// LoginPage.tsx
import React from 'react';
import Login from '../components/Login';
import DynamicLayout from '../components/DynamicLayout';
import NoIndexHelmet from '../components/NoIndexHelmet';

const LoginPage = () => {
    return (
        <DynamicLayout isAuthScreen>
            <NoIndexHelmet title="Login | Saturnalia" />
            <div>
                <div className="full-screen-image-container hundredminnavdesktop margin-top-0" style={{ backgroundImage: `url('/img/saturnwallpaper.jpg')` }}>
                    <Login />
                </div>
            </div>
        </DynamicLayout>
    );
};

export default LoginPage;
